import { Injectable } from '@angular/core';
import { BaseGetProvider } from '@tendercuts/http';
import { Store } from '@tendercuts/models';
import { EndPoint } from '@endpoint';
import { LoginServices } from '../login';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class StoreDetailService extends BaseGetProvider<Store> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
    this.delegate = this;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return Store;
  }

  preProcessResponse(response) {
    return response.results;
  }

  get endpoint() {
    return this.endpointService.storeEndpoint();
  }
}
